import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-message"
export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      const currentId = this.element.id

      document.querySelectorAll("turbo-frame[id^='message_']").forEach(frame => {
        if (frame.id !== currentId) {
          const contentDiv = frame.querySelector("div.markdown-content")
          const thinkingSpan = frame.querySelector("span.thinking")

          if (!contentDiv) return // 🔒 safety

          const childrenTags = [...contentDiv.children].map(el => el.tagName)
          const hasOnlySmallAndThinking =
            thinkingSpan &&
            childrenTags.length === 1 &&
            childrenTags.includes("SPAN")

          if (hasOnlySmallAndThinking) {
            console.log("🧹 Eliminando frame vacío:", frame.id)
            frame.remove()
          } else {
            console.log("✅ Frame conservado:", frame.id)
          }
        }
      })
    })
  }
}
